import DataTable from "@mostrans/web-components/components/advanced/DataTable";
import Button from "@mostrans/web-components/components/base/Button";
import IconButton from "@mostrans/web-components/components/base/IconButton";
import { DATE_FORMAT } from "@mostrans/web-components/constants/dateFormat";
import { Icon } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from 'react';
import ReactQuill from "react-quill";
import styled from "styled-components";
import { useGetMasterTestimoniWithFilter } from "../../../../GQL/Testimonial/useGetMasterTestimoniWithFilter";
import Badge from "../../../../components/General/Badge";
import Case from "../../../../components/General/Case";
import LoadingFallback from "../../../../components/General/LoadingFallback";
import { FlexColumn } from "../../../../components/Layout/Flex";
import { useModals } from "../../../../shared/hooks/useModals";

const SquareContainer = styled.div`
    display: flex;
    position: relative;
    height: 6rem;
    width: 6rem;
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 10%;
    overflow: hidden;   
    &:hover .img-avatar {
        opacity: 0.5;
        cursor: pointer;
      }
`
const ImgAvatar = styled.img`
    object-fit: cover;
    opacity: 1;
    transition: opacity 0.2s ease-in-out;
    width: 6rem;
`;

function ListingTestimonial() {
    const { filteredTestimoni, dataTestimoni, refetchOnchange } = useGetMasterTestimoniWithFilter()
    const [expandedRows, setExpandedRows] = useState([]);
    const { showModal } = useModals()

    useEffect(() => {
        refetchOnchange();
    }, [refetchOnchange]);

    const toggleRow = (rowId) => {
        if (expandedRows.includes(rowId)) {
            setExpandedRows(expandedRows.filter(id => id !== rowId));
        } else {
            setExpandedRows([...expandedRows, rowId]);
        }
    };

    const renderLongText = (longtext, rowId) => {
        if (expandedRows.includes(rowId)) {
            return longtext
        } else {
            return longtext.slice(0, 150)
        }
    };


    return (
        <div className="mt-1">
            <Case
                when={!dataTestimoni.loading}
                then={
                    <DataTable
                        hasPagination
                        data={filteredTestimoni}
                        getRowKey={(data) => data.id}
                        columns={[
                            {
                                selector: "id",
                                getCellKey: (data) => "id" + data.id,
                                renderCell: (data) => (
                                    <IconButton onClick={() => showModal("editTestimoni", data)}>
                                        <Icon>edit</Icon>
                                    </IconButton>
                                )
                            },
                            {
                                header: "Employee Name",
                                selector: "employee_name",
                                headerCellStyle: {
                                    width: "200px"
                                },
                                getCellKey: (data) => "emp_name" + data.id,
                                renderCell: (data) => (
                                    <FlexColumn>
                                        {data?.karyawan?.employee_name}
                                        <div>
                                            <Badge>
                                                {data?.karyawan?.jabatan?.position_name}
                                            </Badge>
                                        </div>
                                    </FlexColumn>
                                )
                            },
                            {
                                header: "Testimoni Content",
                                selector: "testimony",
                                headerCellStyle: {
                                    width: "500px"
                                },
                                getCellKey: (data) => "testimony" + data.id,
                                renderCell: (data) => (
                                    <React.Fragment>
                                        <ReactQuill
                                            theme="bubble"
                                            value={renderLongText(data?.testimony, data.id)}
                                            // style={{ marginBottom: "-4rem" }}
                                            readOnly
                                        />
                                        {
                                            data.testimony.length >= 150 && (
                                                <Button onClick={() => toggleRow(data.id)}>
                                                    {expandedRows.includes(data.id) ? 'Read Less' : 'Read More'}
                                                </Button>
                                            )
                                        }
                                    </React.Fragment>
                                )
                            },
                            {
                                header: "Image",
                                selector: "url_image",
                                getCellKey: (data) => "url_image" + data.id,
                                renderCell: (data) => (
                                    <SquareContainer>
                                        <ImgAvatar
                                            className="img-avatar"
                                            src={data?.url_image}
                                            onClick={() => window.open(data?.url_image, '_blank')}
                                        />
                                    </SquareContainer>
                                )
                            },
                            {
                                header: "Created Date / Status",
                                selector: 'create_date',
                                getCellKey: (data) => "create_date" + data.id,
                                renderCell: (data) => (
                                    <FlexColumn>
                                        <div>
                                            <Badge variant={data?.deleted_date ? "danger" : "primary"}>
                                                {data?.deleted_date ? "Inactive" : "Active"}
                                            </Badge>
                                        </div>
                                        <b className="text-primary-main">{moment(data?.create_date, DATE_FORMAT.unix).format("DD MMMM YYYY HH:mm")}</b>
                                    </FlexColumn>
                                )
                            }
                        ]}
                    />
                }
                else={<LoadingFallback />}
            />
        </div>
    )
}

export default ListingTestimonial